/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { withRouter } from 'react-router';
import connect from 'react-redux/es/connect/connect';
// actions
import { resendInvite } from 'state/actions/accountState/account_data';
// component
import NewInvitationSent from 'pages/auth/newinvitationsent/newinvitationsent';



/* ========== ~~~~~~~~~~ AUTH NEW INVITATION SENT : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ authStatus }) => ({
    tokenData: authStatus.tokenData
});
// map actions
const mapDispatchToProps = dispatch => ({
    resendInvite: (userUUID, isResend) => dispatch(resendInvite(userUUID, isResend))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(NewInvitationSent));
